import React from "react";

const caseStudyContent = [
  {
    caseContent: [
      {
        dealyAnimation: "100",
        title: "CLIENT",
        subTitle1: `Paul Themes Company,
                `,
        subTitle2: "Russia",
        subTitle3: "",
      },
      {
        dealyAnimation: "200",
        title: "SERVICES",
        subTitle1: `UI/UX, Back-End,`,
        subTitle2: "Front-End, Graphic Design,",
        subTitle3: "Animation",
      },
    ],
  },
  {
    caseContent: [
      {
        dealyAnimation: "300",
        title: "TEAM",
        subTitle1: `LoganCee - UI/UX Designer
                `,
        subTitle2: "Pavel Suslov - Developer",
        subTitle3: "",
      },
      {
        dealyAnimation: "400",
        title: "DATE",
        subTitle1: `Feburary 25th, 2022`,
        subTitle2: "",
        subTitle3: "",
      },
    ],
  },
];

const WorksCaseStudy = () => {
  return (
    <>
      {caseStudyContent.map((val, i) => (
        <div className="col-xl-3" key={i}>
          {/* <!--Spacer--> */}
          <div className="ptf-spacer" style={{ "--ptf-xxl": "1.25rem" }} />
          {/* <!--Animated Block--> */}
          {val.caseContent.map((item, i) => (
            <div key={i}>
              <div
                className="ptf-animated-block mb-70"
                data-aos="fade"
                data-aos-delay={item.dealyAnimation}
              >
                <h5 className="fz-14 text-uppercase has-3-color fw-normal">
                  {item.title}
                </h5>
                {/* <!--Spacer--> */}
                <div
                  className="ptf-spacer"
                  style={{ "--ptf-xxl": "1.25rem" }}
                />
                <p className="fz-20 lh-1p5 has-black-color">
                  {item.subTitle1} <br />
                  {item.subTitle2} <br />
                  {item.subTitle3}
                </p>
              </div>
              {/* <!--Spacer--> */}
              <div
                className="ptf-spacer"
                style={{
                  "--ptf-xxl": " 4.375rem",
                  "--ptf-md": "2.1875rem",
                }}
              />
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default WorksCaseStudy;
